import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "title", "subtitle", "instructions", "copyButton"]

  open(event) {
    const {
      app,
      repository,
      issueUrl,
      issueNumber,
      workspace,
      branch,
      checkoutCommand,
      kickoffPrompt,
      callbackDoneCommand,
      callbackBlockedCommand
    } = event.params

    const issueRef = issueUrl && issueUrl.length > 0 ? issueUrl : `${repository}#${issueNumber || "(pending)"}`

    this.titleTarget.textContent = `Coding Agent Instructions: ${app}`
    this.subtitleTarget.textContent = `Target issue: ${issueRef}`
    this.instructionsTarget.value = this.buildInstructions({
      app,
      repository,
      issueRef,
      workspace,
      branch,
      checkoutCommand,
      kickoffPrompt,
      callbackDoneCommand,
      callbackBlockedCommand
    })

    if (this.hasCopyButtonTarget) {
      this.copyButtonTarget.textContent = "Copy Instructions"
    }

    this.dialogTarget.showModal()
    document.body.style.overflow = "hidden"
    this.instructionsTarget.focus()
    this.instructionsTarget.select()
  }

  close() {
    if (this.hasDialogTarget && this.dialogTarget.open) {
      this.dialogTarget.close()
    }
    document.body.style.overflow = ""
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  async copy() {
    const text = this.instructionsTarget.value

    try {
      await navigator.clipboard.writeText(text)
      if (this.hasCopyButtonTarget) {
        this.copyButtonTarget.textContent = "Copied"
        setTimeout(() => {
          this.copyButtonTarget.textContent = "Copy Instructions"
        }, 1500)
      }
    } catch (error) {
      console.error("Failed to copy instructions:", error)
      this.instructionsTarget.focus()
      this.instructionsTarget.select()
    }
  }

  buildInstructions({ app, repository, issueRef, workspace, branch, checkoutCommand, kickoffPrompt, callbackDoneCommand, callbackBlockedCommand }) {
    return [
      `Implement issue ${issueRef} end-to-end.`,
      "",
      "Context",
      `- App: ${app}`,
      `- Repository: ${repository}`,
      "",
      "Workspace",
      `${workspace || "(set local repo path)"}`,
      "",
      "Branch",
      `${branch}`,
      "",
      "Commands",
      `${checkoutCommand}`,
      "",
      "Kickoff Prompt",
      `${kickoffPrompt}`,
      "",
      "Execution Discipline",
      "- Follow docs/operations/CROSS_APP_EXECUTION_PROTOCOL.md",
      "- Complete docs/operations/SESSION_HANDOFF.md before ending session",
      "- Run relevant tests and include validation details in handoff",
      "",
      "Completion Callback (required)",
      "- Export SERIS_API_KEY with a SERIS API token before running these callbacks",
      `- Done callback: ${callbackDoneCommand}`,
      `- Blocked callback: ${callbackBlockedCommand}`
    ].join("\n")
  }
}
